// Animated splash screen shown on first load
import React, { useEffect, useState } from 'react';
import NavImage from '../../resources/NavImage';
import { useT } from '../../i18n';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

const SHOW_MS = 1800; // logo animation + short hold
const FADE_MS = 350;

const LoadingComponent = ({ onDone }) => {
  const [leaving, setLeaving] = useState(false);
  const { t } = useT();

  useEffect(() => {
    const show = prefersReducedMotion() ? 600 : SHOW_MS;
    const leaveTimer = setTimeout(() => setLeaving(true), show);
    const doneTimer = setTimeout(() => onDone && onDone(), show + FADE_MS);
    return () => {
      clearTimeout(leaveTimer);
      clearTimeout(doneTimer);
    };
  }, [onDone]);

  return (
    <div className={`splash${leaving ? ' splash-leave' : ''}`} role="status" aria-label={t('Loading Sara777')}>
      <div className="splash-logo">
        <NavImage />
      </div>
      <p className="brand-tagline splash-tagline">{t("Every Win, Securely Paid.")}</p>
      <div className="splash-dots" aria-hidden="true">
        <span /><span /><span />
      </div>
      <p className="splash-version">{t("App version {version}",{version:"3.0"})}</p>
    </div>
  );
};

export default LoadingComponent;
